/**
 * Quiz Step Routes Mapping
 * 
 * Maps currentStep number to quiz route.
 * Separated to avoid circular dependencies.
 */

export const QUIZ_STEP_ROUTES: Record<number, string> = {
  0: '/quiz', // Intro (QUIZ-002-1)
  1: '/quiz/step/1', // QUIZ-002-2
  2: '/quiz/step/2', // QUIZ-002-3
  3: '/quiz/step/3', // QUIZ-002-4
  4: '/quiz/step/4', // QUIZ-002-5
  5: '/quiz/step/5', // QUIZ-002-6
  6: '/quiz/step/6', // QUIZ-002-7
  7: '/quiz/step/7', // QUIZ-002-8
  8: '/quiz/step/8', // QUIZ-002-9
  9: '/quiz/step/9', // QUIZ-002-10
  10: '/quiz/step/10', // QUIZ-002-11
  11: '/quiz/step/11', // QUIZ-002-12
  12: '/quiz/step/12', // QUIZ-002-13
  13: '/quiz/step/13', // QUIZ-002-14
  14: '/quiz/step/14', // QUIZ-002-15
  15: '/quiz/step/15', // QUIZ-002-16
};

export const TOTAL_MAIN_STEPS = 9;

/**
 * Get route for a given step number
 */
export function getRouteForStep(step: number): string {
  return QUIZ_STEP_ROUTES[step] || `/quiz/step/${step}`;
}
